import SitePage from "@/components/application/site-page";
import { ReactNode } from "react";

function RefundPage() {
  return (
    <>
      <h1>Política de Reembolso</h1>
      <p>
        <strong>Última actualización:</strong> 26 de julio de 2026
      </p>

      <p>
        Esta Política de Reembolso aplica a las suscripciones adquiridas a
        través de BrickGestor, operado por{" "}
        <strong>Gatito Pirata Technologies EIRL</strong>, RUC 20616175221,
        Perú.
      </p>

      <h2>1. Naturaleza del servicio</h2>
      <p>
        BrickGestor es una plataforma digital de Software como Servicio
        (SaaS) que brinda acceso inmediato a herramientas en línea para
        gestionar inventario, precios y ventas de LEGO.
      </p>
      <p>
        Al ser un servicio digital entregado electrónicamente, BrickGestor
        no involucra la entrega de bienes físicos.
      </p>

      <h2>2. Derecho a la información y transparencia</h2>
      <p>Antes de suscribirse, los usuarios son informados claramente sobre:</p>
      <ul>
        <li>Precios y frecuencia de facturación</li>
        <li>Funciones incluidas en cada plan</li>
        <li>Si hay una prueba gratuita disponible</li>
        <li>Condiciones de cancelación y reembolso</li>
      </ul>
      <p>
        Al completar una suscripción, el usuario confirma que ha revisado y
        aceptado estas condiciones.
      </p>

      <h2>3. Reembolsos para suscripciones por primera vez</h2>
      <p>
        La ley peruana de protección al consumidor no exige un plazo
        general e incondicional de desistimiento para servicios digitales.
        Como medida de buena voluntad, y además de cualquier derecho que
        puedas tener bajo la ley de protección al consumidor aplicable,
        BrickGestor ofrece voluntariamente a los nuevos suscriptores un
        reembolso completo si lo solicitan dentro de los 14 días
        posteriores al pago inicial.
      </p>
      <p>
        Para solicitar este reembolso, contáctanos antes de que expire el
        plazo de 14 días, como se describe en la Sección 5 a continuación.
      </p>

      <h2>4. Fallas del servicio y excepciones legales</h2>
      <p>
        De acuerdo con el Código de Protección y Defensa del Consumidor
        (Ley N.° 29571), los usuarios pueden tener derecho a medidas
        correctivas (incluyendo reembolsos o créditos) si:
      </p>
      <ul>
        <li>El servicio no se presta según lo anunciado</li>
        <li>
          Existe una falla técnica prolongada o recurrente atribuible a
          BrickGestor
        </li>
        <li>Al usuario se le cobra incorrectamente</li>
      </ul>
      <p>
        Cada caso será evaluado individualmente para determinar la solución
        apropiada.
      </p>

      <h2>5. Cómo solicitar un reembolso</h2>
      <p>Las solicitudes de reembolso deben enviarse a:</p>
      <p>
        <a href="mailto:brickgestor@gatitopirata.com">
          brickgestor@gatitopirata.com
        </a>
      </p>
      <p>Por favor incluye:</p>
      <ul>
        <li>Dirección de correo electrónico de la cuenta</li>
        <li>Plan de suscripción</li>
        <li>Descripción del problema o motivo de la solicitud</li>
      </ul>
      <p>
        Respondemos a las solicitudes de reembolso dentro de 3 a 5 días
        hábiles.
      </p>

      <h2>6. Procesamiento de reembolsos</h2>
      <ul>
        <li>
          Los reembolsos aprobados se emiten usando el método de pago
          original.
        </li>
        <li>
          Los tiempos de procesamiento dependen del proveedor de pagos y
          pueden tomar de 5 a 10 días hábiles.
        </li>
        <li>
          Las comisiones de transacción o procesamiento cobradas por
          terceros pueden excluirse, cuando esté legalmente permitido.
        </li>
      </ul>

      <h2>7. Política de cancelación</h2>
      <p>
        Los usuarios pueden cancelar su suscripción en cualquier momento
        desde el panel de su cuenta.
      </p>
      <ul>
        <li>La cancelación evita cargos futuros</li>
        <li>La cancelación no implica automáticamente un reembolso</li>
        <li>
          El acceso permanece activo hasta el final del período de
          facturación pagado, a menos que se apruebe un reembolso
        </li>
      </ul>

      <h2>8. Actualizaciones de la política</h2>
      <p>
        BrickGestor puede actualizar esta Política de Reembolso para
        reflejar cambios en la legislación o en las prácticas comerciales.
        Todas las actualizaciones se publicarán en esta página con la
        fecha de revisión correspondiente.
      </p>

      <h2>9. Contacto y soporte al consumidor</h2>
      <p>
        Si tienes preguntas, reclamos o solicitudes de reembolso, puedes
        contactarnos en:
      </p>
      <p>
        <strong>Gatito Pirata Technologies EIRL</strong>
        <br />
        Correo:{" "}
        <a href="mailto:brickgestor@gatitopirata.com">
          brickgestor@gatitopirata.com
        </a>
      </p>
    </>
  );
}

RefundPage.layout = (page: ReactNode) => <SitePage children={page} />;

export default RefundPage;
